import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function FirstDropCard() {
  const checklist = ['First flavour: Citrus', 'First drop: 250 pouches', 'Early access gets notified first', 'Made for Australia'];
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-77">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-charcoal rounded-[2.5rem] p-8 md:p-12 lg:p-16" data-id="element-79">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-80">
            {/* Left Column */}
            <div className="space-y-8" data-id="element-81">
              <h2 className="font-headline text-4xl md:text-5xl text-white leading-tight" data-id="element-82">
                250 pouches. <br data-id="element-83" />
                Citrus only. <br data-id="element-84" />
                Early list first.
              </h2>

              <p className="text-lg text-gray-400 leading-relaxed max-w-md" data-id="element-85">
                We're starting small on purpose. The first Citrus drop is
                limited to 250 pouches so early customers can try it first, give
                real feedback, and help shape what comes next.
              </p>

              <div data-id="element-86">
                <a href="https://forms.gle/TCr9CceLKLVH7UWr6" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-pink text-white font-semibold rounded-full hover:opacity-90 transition-opacity" data-id="element-87">
                  JOIN WAITLIST →
                </a>
              </div>
            </div>

            {/* Right Column */}
            <div className="bg-neutral-800 rounded-3xl p-8 md:p-10" data-id="element-88">
              <div className="space-y-6" data-id="element-89">
                {checklist.map((item, i) => <div key={i} className="flex items-center text-white" data-id="element-90">
                    <div className="w-6 h-6 rounded-full bg-lime flex items-center justify-center mr-4 flex-shrink-0" data-id="element-91">
                      <CheckIcon className="w-4 h-4 text-charcoal" strokeWidth={3} data-id="element-92" />
                    </div>
                    <span className="text-lg" data-id="element-93">{item}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}